import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-relics',
  imports: [Link, RouterLink],
  templateUrl: './relics.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './relics.scss',
})
export class Relics {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Relics`);
    this.dynamicTitle.description(`There is no historical evidence to support the authenticity of these relics, and many scholars believe that they are likely to be forgeries.`);
  }
}
